import Vue from 'vue'
import title from './fragments/title'
import { formatDocument } from '@/util/document'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const client = (data) => {
  const client = data?.real_estate

  if (!client) return ''

  return `
    <details>
      ${title(translate(area + 'client'))}
      <content>
        <h6 class="text-uppercase grey--text">
          ${translate(area + 'name')}
        </h6>
        <p class="body-2 mb-3">
          ${client.name}
        </p>

        <h6 class="text-uppercase grey--text">
          ${translate(area + 'document')}
        </h6>
        <p class="body-2 mb-3">
          ${client.cnpj ? formatDocument(client.cnpj) : '---'}
        </p>
      </content>
    </details>
  `
}

export default client
